<template>
  <main-layout>
    <form-layout>
      <div>
        You can provide more than one technologies/products here for listing.
      </div>
      <div :index="index" :key="index" v-for="(tech, index) in form.techs">
        <div class="tech-title" style="padding: 20px 0 14px">
          <strong>{{ `${$t('tech')} ${index + 1}` }}</strong>
          <el-button
            v-if="index > 0"
            @click="removeTech(index)"
            style="margin-left: 12px"
          >
            {{ $t('delete') }}
          </el-button>
        </div>
        <tech :value="tech" ref="tech"></tech>
      </div>
      <el-button v-if="form.techs.length < 3" @click="addTech">{{
        $t('add')
      }}</el-button>
      <div slot="bottom-bar">
        <el-button @click="previous" slot="footer" type="primary">
          {{ $t('previous') }}
        </el-button>
        <el-button @click="submit" slot="footer" type="primary">
          {{ $t('submit') }}
        </el-button>
      </div>
    </form-layout>
    <el-dialog
      :title="$t('terms_and_conditions')"
      :visible.sync="termsVisible"
      width="800px"
    >
      <div v-html="terms" style="max-height: 500px; overflow-y: auto"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="termsVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="doSubmit">{{
          $t('i_agree')
        }}</el-button>
      </span>
    </el-dialog>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layout/main';
import FormLayout from '@/components/layout/form';
import Tech from '@/views/tech';

export default {
  name: 'Techs',
  components: {
    MainLayout,
    FormLayout,
    Tech,
  },
  props: {},
  data() {
    return {
      form: null,
      emptyForm: {
        techs: [],
      },
      terms: '',
      termsVisible: false,
      loadingCount: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    loadTerms() {
      this.loadingCount++;
      this.$axios
        .get('terms')
        .then(({ data }) => {
          this.terms = data.content;
        })
        .catch(() => {})
        .then(() => {
          this.loadingCount--;
        });
    },
    addTech() {
      this.form.techs.push({
        name: '',
        companyId: '',
        description: '',
        advantages: '',
        market: '',
        readiness: '',
        type: [],
        references: '',
        logo: '',
        gallery: [],
        tags: [],
      });
    },
    removeTech(index) {
      this.form.techs.splice(index, 1);
    },
    submit() {
      const self = this;
      (async function () {
        if (self.form.techs.length === 0) return false;
        for (let i = 0; i < self.form.techs.length; i++) {
          const { valid, data } = await self.$refs.tech[i].validate();
          if (!valid) {
            return false;
          }
          self.form.techs[i] = data;
        }
        return true;
      })()
        .then(valid => {
          if (valid) {
            this.$store.commit('selfUpload/setTechs', this.form);
            this.termsVisible = true;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    doSubmit() {
      const self = this;
      self.loadingCount++;
      self.$axios
        .post('misc/tech-providers', self.$store.getters['selfUpload/data'])
        .then(() => {
          this.$store.commit('selfUpload/clear');
          this.$router.push('/success');
        })
        .catch(() => {})
        .then(() => {
          self.loadingCount--;
        });
    },
    previous() {
      this.$router.push('/contacts');
    },
  },
  created() {
    const form = Object.assign({}, this.emptyForm);
    if (this.$store.state.selfUpload.techs) {
      Object.assign(
        form,
        JSON.parse(JSON.stringify(this.$store.state.selfUpload.techs)),
      );
    }
    this.form = form;
    if (this.form.techs.length === 0) {
      this.addTech();
    }
    this.loadTerms();
  },
};
</script>
